import { get, put, post, delete as del, /*head, options, patch,*/ } from 'axios';

const clientApi = {
    GetCurrentUtcDate: () => get('api/ReportDefinition/GetCurrentUtcDate'),
    callBizweaver: (url, parameter, postHeaders) => post(url, parameter, { headers: postHeaders }),
    
   };

export default clientApi;
